import http from 'core/services/http';
import Config from 'core/config';
import isObject from 'lodash/isObject';
import StaffService from '../staff-and-rooms/StaffService';

class ShipmentTrackingService {
  static getShipmentTracking(testCenterCode, days) {
    return http.get(`${Config.apiUrl}/query/testCenterShipments?&testCenterCode=${testCenterCode}&daysInPast=${days}`);
  }
}

export default ShipmentTrackingService;
